import {apiurl} from '@/services/config'

const API_URL = apiurl+ '/backoffice/popup'

export const PopupService = {
  list,
  add,
  edit,
  hapus
}

async function list () {
  const response = await fetch(API_URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  })
  return await handleResponse(response)
}

async function hapus (newsid) {
  return fetch(API_URL + "/"+ newsid, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function add (postdata) {
  return fetch(API_URL, {
    method: 'POST',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

async function edit (postdata) {
  return fetch(API_URL, {
    method: 'PATCH',
    body: JSON.stringify({ postdata }.postdata),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('token')
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)

    if (!data.success) {
      if (response.status === 401) {
        console.log("CALL LOGOUT");
        localStorage.setItem('token',null);
        localStorage.clear();
        location.reload(true)
      }
      const error = (data && data.msg) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
